/* Launcher, panel frame, header, maximize/resize and callout — verbatim from the live
   v2.1.0 widget. The header's look is fixed; restyle the interior in interior.css. */
/* Secure Chat Widget Styles - Complete Feature Set */
.chat-widget-button-container {
  position: fixed;
  bottom: 20px;
  right: 260px; /* Moved button another 60px to the left */
  z-index: 9999;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
}

.chat-widget-panel-container {
  position: fixed;
  bottom: 100px; /* Position above button */
  right: 260px; /* Align with button */
  z-index: 9998; /* Slightly below button */
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
}

.chat-widget-button {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #F3BC44; /* MODIFIED: Icon color changed */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  padding: 0;
}

.chat-widget-button:hover {
  transform: scale(1.05);
  background-color: #e0ac3c; /* MODIFIED: Darker shade for hover */
}

.chat-widget-button svg {
  width: 30px;
  height: 30px;
  fill: white;
}

.chat-widget-panel {
  width: 350px; /* Default width */
  height: 500px; /* Default height */
  min-width: 280px; /* --- RESIZE ADDITION --- */
  min-height: 300px; /* --- RESIZE ADDITION --- */
  max-height: calc(100vh - 40px); /* Consider max height */
  max-width: calc(100vw - 40px); /* Consider max width */
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden; /* --- RESIZE MODIFICATION: Ensure content clipping --- */
  position: relative; /* For resize handle positioning */
  opacity: 0;
  pointer-events: none;
  transform: translateY(20px) scale(0.95);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.chat-widget-panel.open {
  opacity: 1;
  pointer-events: all;
  transform: translateY(0) scale(1);
}

.chat-widget-header {
  padding: 12px 15px;
  background-color: #003da5; /* Dark blue header */
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(0,0,0,0.1);
  cursor: grab;
}

.chat-widget-title {
  font-weight: 600;
  font-size: 20px;
  color: white;
  display: flex;
  align-items: center;
  gap: 8px;
}

.chat-widget-title-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}

.chat-widget-header-buttons {
    display: flex;
    align-items: center;
}
.chat-widget-header-icon-button {
    background: none;
    border: none;
    padding: 5px;
    margin: 0;
    cursor: pointer;
    color: white;
    opacity: 0.8;
    transition: opacity 0.2s ease;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}
.chat-widget-header-icon-button:hover {
    opacity: 1;
}
.chat-widget-header-icon-button svg {
    width: 16px;
    height: 16px;
    stroke-width: 2.5;
}

.chat-widget-new-chat-icon {
     margin-right: 5px;
}

 .chat-widget-close {
    font-size: 26px;
    font-weight: 300;
    line-height: 1;
    padding: 0 5px;
 }
.chat-widget-header-icon-button[data-tooltip]::before {
    content: attr(data-tooltip);
    position: absolute;
    bottom: -28px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 11px;
    white-space: nowrap;
    z-index: 10;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
}

.chat-widget-header-icon-button[data-tooltip]:hover::before {
    opacity: 1;
    visibility: visible;
}

.new-chat-button:hover {
  background-color: rgba(255, 255, 255, 0.35);
}

.chat-widget-close {
  cursor: pointer;
  font-size: 24px;
  line-height: 1;
  padding: 0 5px;
  font-weight: 300;
  opacity: 0.8;
  background: none;
  border: none;
  color: white;
}
.chat-widget-close:hover {
    opacity: 1;
}


/* Maximize/Minimize Styles */
.chat-widget-panel.maximized {
    width: 700px !important;
    height: 90vh !important;
    max-height: 900px !important;
    bottom: 20px !important;
    right: 20px !important;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3) !important;
    transform: translateY(0) scale(1) !important;
}

/* Smooth transition when maximizing */
.chat-widget-panel.open.maximized {
    animation: maximizePanel 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

@keyframes maximizePanel {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.02);
    }
    100% {
        transform: scale(1);
    }
}

@media (max-width: 768px) {
    .chat-widget-panel.maximized {
        width: calc(100vw - 40px) !important;
        height: calc(100vh - 100px) !important;
        max-height: none !important;
    }
}

.chat-widget-maximize-icon {
    margin-right: 5px;
}

/* --- RESIZE ADDITION: Resize Handle Style --- */
.chat-widget-resize-handle {
    position: absolute;
    bottom: 0px;
    right: 0px;
    width: 16px;
    height: 16px;
    cursor: nwse-resize; /* Diagonal resize cursor */
    z-index: 100; /* Ensure it's above footer and other content */
}
.chat-widget-resize-handle::after { /* Optional: Visual cue for the handle */
    content: '';
    position: absolute;
    bottom: 3px;
    right: 3px;
    width: 6px;
    height: 6px;
    border-right: 2px solid rgba(0,0,0,0.3);
    border-bottom: 2px solid rgba(0,0,0,0.3);
    box-sizing: border-box;
}

/* Security message styles */

/* Callout (was injected separately by createCallout). */
.chat-widget-callout {
    position: absolute;
    bottom: 80px;
    right: -60px; /* Moved callout another 60px to the left */
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 20px 40px 20px 20px; /* More padding on right for X button */
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    max-width: 320px;
    min-width: 280px;
    opacity: 0;
    transform: translateY(10px) scale(0.95);
    transition: all 0.3s ease-in-out;
    pointer-events: none;
    z-index: 99999;
}

.chat-widget-callout.visible {
    opacity: 1;
    transform: translateY(0) scale(1);
    pointer-events: auto;
}

.chat-widget-callout::after {
    content: '';
    position: absolute;
    bottom: -8px;
    right: var(--esl-callout-arrow-right, 50px);
    width: 16px;
    height: 16px;
    background: white;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    transform: rotate(45deg);
    z-index: -1;
}

.chat-widget-callout-close {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 24px;
    height: 24px;
    border: none;
    background: none;
    cursor: pointer;
    color: #666;
    font-size: 20px;
    line-height: 1;
    padding: 0;
    transition: color 0.2s;
}

.chat-widget-callout-close:hover {
    color: #333;
}

.chat-widget-callout-content {
    display: flex;
    align-items: center;
    gap: 12px;
}

.chat-widget-callout-icon {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
}

.chat-widget-callout-text {
    flex: 1;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #333;
}

@media (max-width: 480px) {
    .chat-widget-callout {
        max-width: calc(100vw - 100px);
        right: 60px; /* Maintain left offset on mobile */
        bottom: 90px;
    }

    .chat-widget-callout::after {
        right: 48px; /* Adjust arrow for mobile */
    }
}
